/**
 * scrolls an element to the top of the viewport
 * only modern browser will be able to do a smooth scroll
 * @param {HTMLElement} element - html element
 * @param {string} behavior - scroll behavior, default is 'smooth'
 * @param {number} timeout - timeout in ms, default is 0
 */
const scrollToElement = (element, behavior = "smooth", timeout = 0) => {
	setTimeout(() => {
		const header = document.querySelector(".Header");
		const headerHeight = header ? header.offsetHeight : 0;

		// Check if there is a label element before the current element
		const previousElement = element.previousElementSibling;
		const targetElement =
			previousElement && previousElement.tagName === "LABEL"
				? previousElement
				: element;

		// If targetElement is a label add an extra 16px space, otherwise no extra space.
		const extraSpace = targetElement.tagName === "LABEL" ? 16 : 0;

		const scrollTop =
			targetElement.getBoundingClientRect().top +
			window.pageYOffset -
			headerHeight -
			extraSpace;

		window.scrollTo({ top: scrollTop, behavior });
	}, timeout);
};

/**
 * Checks if a given file is present in an array of files.
 * @param {object} file - The file to check for.
 * @param {Array<object>} fileArray - The array of files to search within.
 * @returns {boolean} - Returns true if the file is found in the array, otherwise false.
 */
const containsFile = (file, fileArray) => {
	return fileArray.some((allowedFile) => allowedFile.name === file.name);
};

/**
 * Converts a file to a base64 string.
 * @param {File} file - The file to convert.
 * @returns {Promise<string>} The base64 string of the file.
 * @private
 */
const getBase64 = (file) => {
	return new Promise((resolve) => {
		const reader = new FileReader();

		reader.addEventListener("load", () => {
			resolve(reader.result);
		});

		reader.readAsDataURL(file);
	});
};

/**
 * Recursively converts an array of files to an array of objects containing file names
 * and their base64 representations.
 * @param {File[]} files - An array of File objects to be converted.
 * @param {object[]} [filesBase64] - An array to store the converted files. Each object contains the file name and its base64 representation.
 * @returns {Promise<object[]>} A promise that resolves to an array of objects, each containing the file name and its base64 representation.
 * @private
 */
const getFilesAsBase64 = async (files, filesBase64 = []) => {
	const file = files.shift();
	const uploadFileArray = filesBase64;

	if (file) {
		const fileBase64 = await getBase64(file);
		uploadFileArray.push({
			name: file.name,
			base64: fileBase64,
		});
		return await getFilesAsBase64(files, uploadFileArray);
	} else {
		return uploadFileArray;
	}
};

const getRandomInt = (max) => {
	return Math.floor(Math.random() * max);
};

export {
	containsFile,
	getFilesAsBase64,
	getBase64,
	scrollToElement,
	getRandomInt,
};
